import { render, staticRenderFns } from "./BlockResv.vue?vue&type=template&id=4d83f24c&scoped=true"
import script from "./BlockResv.vue?vue&type=script&lang=js"
export * from "./BlockResv.vue?vue&type=script&lang=js"
import style0 from "./BlockResv.vue?vue&type=style&index=0&id=4d83f24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83f24c",
  null
  
)

export default component.exports